import React from 'react';
import { Instagram, Facebook, Linkedin, Youtube, MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-800 text-white" data-id="element-138" data-mp="3ghc2o28413o8">
      {/* NAP block */}
      <div className="border-b border-white/10" data-id="element-139" data-mp="32p5qssbzpiul">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16" data-id="element-140" data-mp="36pfv80k4w17c">
          <div className="grid lg:grid-cols-12 gap-10" data-id="element-141" data-mp="36n3dnoiafsut">
            <div className="lg:col-span-5" data-id="element-142" data-mp="3ug3c3bc12161">
              <div className="text-3xl font-extrabold tracking-tight text-white mb-2" data-id="element-143" data-mp="3ud7hnwze1umc">
                Langler Air
              </div>
              <div className="text-xs font-semibold uppercase tracking-widest text-accent mb-5" data-id="element-144" data-mp="3lf582t1l9tng">
                Mitsubishi Diamond Dealer
              </div>
              <p className="text-xl font-bold tracking-tight leading-tight text-white/95 max-w-md" data-id="element-145" data-mp="3qf9raqtvt2hd">
                Perth aircon, installed right since 1995. Family run from
                Balcatta.
              </p>
            </div>

            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-8" data-id="element-146" data-mp="3l90pe0juz71d">
              <div className="space-y-4" data-id="element-147" data-mp="3gagyrmubl72o">
                <div className="text-[11px] uppercase tracking-widest font-semibold text-white/60" data-id="element-148" data-mp="3gbiliokp7i08">
                  Workshop
                </div>
                <div className="flex items-start gap-3" data-id="element-149" data-mp="3v5dfypk3x4rw">
                  <MapPin size={17} className="text-accent mt-0.5 flex-shrink-0" data-id="element-150" data-mp="3q7u1ppnesrzy" />
                  <a href="https://maps.google.com/?q=Unit+2%2F3+Cressall+Rd%2C+Balcatta+WA+6021" target="_blank" rel="noopener noreferrer" className="text-base text-white hover:text-accent transition-colors leading-snug" data-id="element-151" data-mp="80nu4lf3sudx">
                    Unit 2/3 Cressall Rd
                    <br data-id="element-152" data-mp="qu1gi24r3shx" />
                    Balcatta WA 6021
                  </a>
                </div>
                <div className="flex items-start gap-3" data-id="element-153" data-mp="mthkx2ztswxw">
                  <Clock size={17} className="text-accent mt-0.5 flex-shrink-0" data-id="element-154" data-mp="tvmpxgmhyeld" />
                  <span className="text-base text-white leading-snug" data-id="element-155" data-mp="yupiw2p7cucz">
                    Mon–Thu 9am–4pm
                    <br data-id="element-156" data-mp="13rzkegpv8wh6" />
                    Fri 9am–2pm
                  </span>
                </div>
              </div>

              <div className="space-y-4" data-id="element-157" data-mp="18ltx30720b6r">
                <div className="text-[11px] uppercase tracking-widest font-semibold text-white/60" data-id="element-158" data-mp="1ckkoqrsr30mh">
                  Contact
                </div>
                <a href="tel:+61864043888" className="flex items-center gap-3 group" data-id="element-159" data-mp="1hmidu2nu0pnc">
                  <Phone size={17} className="text-accent flex-shrink-0" data-id="element-160" data-mp="1rj4xwp8c3cob" />
                  <span className="text-base text-white group-hover:text-accent transition-colors tabular-nums font-bold" data-id="element-161" data-mp="3ob57041gd35n">
                    08 6404 3888
                  </span>
                </a>
                <a href="mailto:info@langlerair.com.au" className="flex items-center gap-3 group" data-id="element-162" data-mp="2aevdxsrcbo5s">
                  <Mail size={17} className="text-accent flex-shrink-0" data-id="element-163" data-mp="25mu7ingusrno" />
                  <span className="text-base text-white group-hover:text-accent transition-colors" data-id="element-164" data-mp="21m0fbhwdoqoz">
                    info@langlerair.com.au
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Link columns */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16" data-id="element-165" data-mp="2pc4l9vx1h2j5">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-166" data-mp="2kd1eo71euo92">
          <div data-id="element-167" data-mp="2kbgmgo2kjhed">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-168" data-mp="2kf4grpfu87u5">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-169" data-mp="18yedae2stu48">
              <li data-id="element-170" data-mp="18w1p3j6g6niq">
                <a href="/ducted-air-conditioning/" className="text-white/90 hover:text-accent transition-colors" data-id="element-171" data-mp="13z1i961rxgqk">
                  Ducted reverse cycle
                </a>
              </li>
              <li data-id="element-172" data-mp="2wn9aa8kvgz2y">
                <a href="/split-systems-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-173" data-mp="2wnr1urwlap4j">
                  Split systems
                </a>
              </li>
              <li data-id="element-174" data-mp="3bjqgymi49pj6">
                <a href="/reverse-cycle-air-conditioning-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-175" data-mp="3bj6y93kn6x43">
                  Reverse cycle
                </a>
              </li>
              <li data-id="element-176" data-mp="31nn7evkxqom7">
                <a href="/commercial-air-conditioning-installation-in-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-177" data-mp="36kne98plzved">
                  Commercial HVAC
                </a>
              </li>
              <li data-id="element-178" data-mp="1v71mrgwa1hpo">
                <a href="/air-conditioner-removals/" className="text-white/90 hover:text-accent transition-colors" data-id="element-179" data-mp="1v343mv9p8q5s">
                  Removal and disposal
                </a>
              </li>
              <li data-id="element-180" data-mp="1wmw1j61soolz">
                <a href="/smart-zone/" className="text-white/90 hover:text-accent transition-colors" data-id="element-181" data-mp="1wlcg711a7ndc">
                  Smart Zone control
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-182" data-mp="zwwszbln9q3e">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-183" data-mp="zx6b6d0g6syj">
              Brands
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-184" data-mp="1dp2xu1jckanj">
              <li data-id="element-185" data-mp="18wjip050h7gm">
                <a href="/brand/mitsubishi-air-conditioner-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-186" data-mp="18w0awc92rzgb">
                  Mitsubishi Electric
                </a>
              </li>
              <li data-id="element-187" data-mp="2gan8c24t1n09">
                <a href="/brand/daikin-air-conditioning-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-188" data-mp="2gb5atgi28xgm">
                  Daikin
                </a>
              </li>
              <li data-id="element-189" data-mp="2q18fwf2gi1vb">
                <a href="/brand/rinnai-air-conditioning-perth/" className="text-white/90 hover:text-accent transition-colors" data-id="element-190" data-mp="2q2szj9n8g0ee">
                  Rinnai HRV
                </a>
              </li>
              <li data-id="element-191" data-mp="22bxb8mhzjnbw">
                <a href="/smart-zone/" className="text-white/90 hover:text-accent transition-colors" data-id="element-192" data-mp="22be480tvijcn">
                  iZone Smart Home
                </a>
              </li>
              <li data-id="element-193" data-mp="2b97naa2mnghv">
                <a href="/best-ducted-air-conditioning-2026/" className="text-white/90 hover:text-accent transition-colors" data-id="element-194" data-mp="3ipe1f41c3uw7">
                  Best ducted 2026
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-195" data-mp="1b56tyxw31tyb">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-196" data-mp="1720se3jx0qy6">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-197" data-mp="129r5yxi0e90n">
              <li data-id="element-198" data-mp="xbz3xannh6iq">
                <a href="#installation-standard" className="text-white/90 hover:text-accent transition-colors" data-id="element-199" data-mp="xch7ytgk0p17">
                  Installation standard
                </a>
              </li>
              <li data-id="element-200" data-mp="nc8a7b6wyvjp">
                <a href="#pricing" className="text-white/90 hover:text-accent transition-colors" data-id="element-201" data-mp="nfvzfy5bsvsm">
                  Pricing
                </a>
              </li>
              <li data-id="element-202" data-mp="2dq7cg1bl5fbd">
                <a href="#reviews" className="text-white/90 hover:text-accent transition-colors" data-id="element-203" data-mp="2dqqv5k9287qg">
                  Reviews
                </a>
              </li>
              <li data-id="element-204" data-mp="1hmthmw2c7iux">
                <a href="/contact/" className="text-white/90 hover:text-accent transition-colors" data-id="element-205" data-mp="1hmabecm1uiwq">
                  Contact
                </a>
              </li>
              <li data-id="element-206" data-mp="17vp5e441qc3s">
                <a href="/contact/" className="text-white/90 hover:text-accent transition-colors" data-id="element-207" data-mp="1cv20td8zgrhz">
                  Service areas
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-208" data-mp="12xnit97evunk">
            <h4 className="text-[11px] uppercase tracking-widest font-semibold text-white/60 mb-5" data-id="element-209" data-mp="12y72ovgmgt48">
              Follow
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-210" data-mp="tvxu4b4wz9th">
              <li data-id="element-211" data-mp="twpqho6c5bkt">
                <a href="https://www.instagram.com/LanglerAir/" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-212" data-mp="tya8kebgr21s">
                  <Instagram size={15} data-id="element-213" data-mp="cn513a0vfd8i" /> Instagram
                </a>
              </li>
              <li data-id="element-214" data-mp="7pbw2kbb0p9t">
                <a href="https://www.facebook.com/langlerair/" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-215" data-mp="7lo1dhu4hwti">
                  <Facebook size={15} data-id="element-216" data-mp="vbid1w2phfc6" /> Facebook
                </a>
              </li>
              <li data-id="element-217" data-mp="qdgwpiwnzu4e">
                <a href="https://www.linkedin.com/company/langler-air/" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-218" data-mp="qgcsb0l1i6po">
                  <Linkedin size={15} data-id="element-219" data-mp="3735rnvri2cin" /> LinkedIn
                </a>
              </li>
              <li data-id="element-220" data-mp="325dryfkm5m3w">
                <a href="https://www.youtube.com/@langlerair" target="_blank" rel="noopener noreferrer" className="text-white/90 hover:text-accent transition-colors inline-flex items-center gap-2" data-id="element-221" data-mp="325vz478tdkql">
                  <Youtube size={15} data-id="element-222" data-mp="8way26kk5s5a" /> YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10" data-id="element-223" data-mp="11jomthe3rheb">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-xs text-white/60" data-id="element-224" data-mp="11mkn3cdfai5x">
          <div className="tabular-nums" data-id="element-225" data-mp="rtc4lvtrg0bc">
            ABN 87 134 927 585 · ©2026 Langler Air Pty Ltd
          </div>
          <div className="flex items-center gap-5" data-id="element-226" data-mp="mtr6fnmezvzo">
            <a href="/privacy/" className="hover:text-accent transition-colors" data-id="element-227" data-mp="1kbhffap9f0li">
              Privacy
            </a>
            <a href="/terms/" className="hover:text-accent transition-colors" data-id="element-228" data-mp="1fjppn2dxgywf">
              Terms
            </a>
            <span data-id="element-229" data-mp="1nuyeomsq4l33">Perth, Western Australia</span>
          </div>
        </div>
      </div>
    </footer>;
}